import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { SMARTCONSENT_DOMAIN } from '../config/configuration';
import SITE_PATHS from '../config/sitePaths';

import { getUserFromToken } from '../utils/auth/authenticatedUser';
import { getHashValue } from '../utils/urlHelpers';
import Loader from './Loader';

const oneHourInMilliseconds = 60 * 60 * 1000;

export default function SignInCallback(props) {
  const [done, setDone] = useState(false);
  const { location: { hash }, history } = props;

  useEffect(() => {
    const doFederatedSignIn = (token) => {
      Auth.federatedSignIn(
        SMARTCONSENT_DOMAIN,
        {
          token,
          expires_at: new Date().getTime() + oneHourInMilliseconds,
        },
        getUserFromToken(token),
      )
        .catch((error) => {
          history.replace(SITE_PATHS.ROOT);
          console.error('Error on federated signin:', error); // eslint-disable-line no-console
        })
        .finally(() => setDone(true));
    };
    const idToken = getHashValue(hash, 'id_token');
    doFederatedSignIn(idToken);
  }, [hash, history]);

  return done ? <Redirect to={SITE_PATHS.LOANS_LISTING} /> : <Loader />;
}
